export default __webpack_public_path__ + "static/media/warningreport_problem.2203cc4f.svg";